// extracted by mini-css-extract-plugin
export var HomepageHeroCard = "HomepageHeroCard-module--HomepageHeroCard--3sVHD";
export var imageContainer = "HomepageHeroCard-module--imageContainer--2mtxe";
export var image = "HomepageHeroCard-module--image--3Lqp6";
export var copy = "HomepageHeroCard-module--copy--eFcZ7";
export var HomepageHeroCardOnly = "HomepageHeroCard-module--HomepageHeroCardOnly--16_ln";
export var imageCardOnly = "HomepageHeroCard-module--imageCardOnly--1-XKi";
export var copyCardOnly = "HomepageHeroCard-module--copyCardOnly--2E31B";